<app-tool-bar [title]="'Manage Packages'" [iconName]="'pi-box'" [isAdd]="true" (handleAdd)="openAddModal()">
</app-tool-bar>


<div class="p-4 overflow-auto h-[85vh]">
    <p-table [value]="packages" [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" [loading]="loading"
        [rowsPerPageOptions]="totalRecords > 10 ? [10, 20, 50] : undefined" [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

        <ng-template pTemplate="header">
            <tr>
                <th>Package Id</th>
                <th>Package Name</th>
                <th>Features</th>
                <th>Type</th>
                <th>Is Customise</th>
                <th>Status</th>
                <th>Validity</th>
                <th>Action</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-package>
            <tr>
                <td>{{ package.package_id }}</td>
                <td>{{ package.package_name || 'N/A' }}</td>
                <td>{{ getAllFeatures(package.features) || 'N/A' }}</td>
                <td>{{ package.type || 'N/A' }}</td>
                <td>{{ package.is_customized }}</td>
                <td>{{ package.status || 'N/A' }}</td>
                <td>{{ package.validity || 'N/A' }}</td>
                <td>
                    <button pButton type="button" icon="pi pi-ellipsis-v" class="p-button-text p-button-sm"
                        (click)="openMenu($event, package)">
                    </button>
                </td>

            </tr>
        </ng-template>

        <ng-template pTemplate="loading">
            <tr>
                <td colspan="6" class="text-center">
                    <p-progressSpinner></p-progressSpinner>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="6" class="no-data">
                    <p>No records found</p>
                </td>
            </tr>
        </ng-template>


    </p-table>

    <p-menu #actionMenu [model]="actionItems" popup="true"></p-menu>

</div>


<ng-container *ngIf="showAddModal">
    <p-dialog [(visible)]="showAddModal" [modal]="true" [style]="{width: '50rem'}">
        <app-create-package (close)="closeAddModal()" (reload)="loadPackages()" />
    </p-dialog>
</ng-container>


<ng-container *ngIf="showEditModal">
    <p-dialog [(visible)]="showEditModal" [modal]="true" [style]="{width: '50rem'}">
        <app-create-package (close)="showEditModal = false" [type]="'Update'" [selectedPackage]="selectedPackage"
            (reload)="loadPackages()" />
    </p-dialog>
</ng-container>


<ng-container *ngIf="showDeleteModal">
    <p-dialog [(visible)]="showDeleteModal" [modal]="true" [style]="{width: '30rem'}">
        <app-delete-package
        (close)="showDeleteModal = false" [selectedPackage]="selectedPackage"
            (reload)="loadPackages()" />
    </p-dialog>
</ng-container>